function te(i,e){void 0;}
function loginpage(){

	var view = {

        updateTos: false,

		setEventListeners: function() {
            // clear any old cookies
            POP.clearCookies();

			$('#loginForm').submit(this.validateForm);
			$('#resetForm').submit(this.passwordReset);

			// toggle views
			$('#trigger-reset').click(this.showPasswordReset);
			$('#trigger-login').click(this.showLogin);
		},

		showPasswordReset: function(e) {
			e.preventDefault();

			$('#loginForm').addClass('hidden');
			$('#resetForm').removeClass('hidden');
			$('#small-form-heading').text('RESET YOUR PASSWORD');
		},

		showLogin: function(e) {
			e.preventDefault();

			$('#resetForm').addClass('hidden');
			$('#loginForm').removeClass('hidden');
			$('#small-form-heading').text('LOGIN TO POP');
		},

		loginHandler:function(e) {
			var $form = $('#loginForm');

			void 0;

			// successful password reset
            if (e.code == 202) {
            	// trigger login form and success message
            	view.showMessage('Your password has been updated. Please wait while we redirect you to the login page.', true, $form);
            	
            	setTimeout(function() {
            		window.location.href = '/login'
            	}, 2000);

            	return;
            }

            if (typeof e.msg != "undefined") {
                view.showMessage(e.msg, e.code == 200, $form);
            } else {
                view.showMessage(POP.messages.loggedin, e.code == 200, $form);
            }

			if (e.code == 200) {
				POP.clearCookies();

                $.cookie('pop_weasel', e.data.token, { path:'/', domain:'.pop.co' });
                $.cookie('pop_domain', e.data.email.split('@')[1], { path:'/', domain:'.pop.co' });

                // update tos acceptance date if needed
                if (view.updateTos) {
                    $.post(POP.apiBaseUrl + '/user/update/tos');
                }

                if (typeof e.data.url != 'undefined' && e.data.url.length) {
					view.redirect(e.data.url);
				} else if (POP.loginRedirect) {
					view.redirect(POP.loginRedirect);
				} else {
					view.redirect($.url(window.location.href).param('r'));
				}

                return true;
			}
		},

		passwordResetHandler: function(response) {
			var $form = $('#resetForm');

			// console.log(response);
			POP.Ajax.done($form.find('button'));

			if (typeof response.msg != "undefined") {
				if (response.code == 200) {
					view.showMessage(response.msg, true, $form);
				} else {
					view.showMessage(response.msg, false, $form);
				}
			} else {
				view.showMessage(POP.messages.genericError, false, $form);
			}
		},

		/**
		 * Handle the actual login.
		 */
		validateForm: function(e) {
			var $form = $(this);

			e.preventDefault();

			// clean our slate
			view.clearMessage(false, $form);

			// validate the form
			$form.find('input').each(view.validateText);

                        // only allow submit if no errors
			if ($form.find('input.has-error').length == 0) {
                            view.submitForm($form, window.tempCode ? '/user/resetpasswordemail' : '/user/login/', view.loginHandler);
			}
		},

		/**
		 * Handle the password reset.
		 */
		passwordReset: function(e) {
			var $form = $(this),
				email = $form.find('input[name=email]').val();

			e.preventDefault();

			// clean our slate
			view.clearMessage(false, $form);

			// validate just email/cell
			if (email.length < 1) {
				view.showMessage("Please enter your email address.", false, $form);
			} else {
				view.submitForm($form, '/user/forgot/', view.passwordResetHandler);
			}
		},

		submitForm: function($form, url, handler) {
			var data = $form.serialize(),
				$btn = $form.find('button[type=submit]');

			POP.Ajax.submitting($btn);

			$.ajax({
				type: "POST",
				url: POP.apiBaseUrl + url,
				data: data,
				success: handler,
				error: function() {
					POP.Ajax.error($form.find('button[type=submit]'));
					handler.apply(this, [{code:555}]);
				},
				headers: {'X-Requested-With': 'XMLHttpRequest'},
				crossDomain:true,
				dataType:"json"
			}).done(function(resp) {
				POP.Ajax.done($form.find('button[type=submit]'), resp)
			});
		},

		redirect: function(redirect) {
			if (typeof redirect == 'undefined' || !redirect || redirect == '') {
				void 0;
				window.location.href = '/panel'
			} else {
				void 0;
				window.location.href = redirect;
			}
		},

		showMessage: function(message, success, $form) {
            var $alert = $form.find('.alert');

			void 0;
            void 0;

            // Clear original content & add new message
            view.clearMessage(success, $form);

            // set new content
			$alert.html(message);

			// Define success / fail styles
			if (success === true) {
				$alert.addClass('alert-success');
			} else {
                $alert.addClass('alert-danger');
            }

            // Display message 
            if (!$alert.hasClass('hidden')) {
            	return;
            } else {
            	$alert.removeClass('hidden').slideDown();	
            }
            
            // POP.scrollTo($alert, true);
			view.scrollToElem($alert);
		},

		clearMessage: function(success, $form) {
			var $alert = $form.find('.alert');
			if (success === true) {
				$alert
					.slideUp()
					.addClass('hidden')
					.removeClass('alert-danger')
					.removeClass('alert-success')
					.html('');
			} else {
				$alert
					.removeClass('alert-danger')
					.html('');
			}
        },

		validateText: function(i,el){
			var elem = $(el);
			var input = elem.val();

			switch (elem.attr('name').toLowerCase()) {
				case 'email':
						view.makeValid(elem, input.length != 0);
					break;
				case 'password':
						view.makeValid(elem, input.length >= 4);
					break;
                case 'tos':
                    if (elem[0].checked) {
                        view.makeValid(elem, true);
                        view.updateTos = true;
                    } else {
                        void 0;
                        view.makeValid(elem, false);
                    }
                    break;
			}
		},

		makeValid: function($elem, valid) {
			if (valid == true) {
				$elem.removeClass("has-error");
			} else {
				$elem.addClass("has-error");
			}
		},

		scrollTo: function(pos) {
			$('html, body').animate({scrollTop: (pos-25)}, 700);
		},

		scrollToElem: function(elem) {
			var windowHeight = $(window).height();
			var scrollTop = $(document).scrollTop();
			var windowBottom = windowHeight + scrollTop;
			var elemTop = $(elem).offset().top;
			if (elemTop < scrollTop || elemTop > windowBottom){
				view.scrollTo(elemTop);
			}
		}
	};

	function start() {
		view.setEventListeners();

		$('[type=text]').eq(0).focus();

		var r = $.url(window.location.href).param('r');
		if (typeof r == 'undefined' || r == '' || r == null) {
			// console.log('you will not be redirected!');
		} else {
			view.showMessage('Please login first.', false, $('#loginFormEmail'));
		}
	}

	start();
}
